import { useWorkspace } from './useWorkspace';

const BILLING_ROLES = new Set(['WORKSPACE_OWNER', 'WORKSPACE_ADMIN', 'SUPER_ADMIN']);

/** Only owners and admins choose plans; everyone else sees plan prompts without checkout. */
export function useCanManageBilling(): boolean {
  const { workspaceId, workspace, workspaces } = useWorkspace();
  const role = (workspaces?.find((item) => item.id === workspaceId) as { role?: string } | undefined)?.role
    ?? (workspace as { role?: string } | null)?.role;
  return !!role && BILLING_ROLES.has(role);
}
